import { call, put } from 'redux-saga/effects';
import Http from '../../../../libs/Http';

export function* fetchOffersByType(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const response = yield call(Http.get, '/offers/offersByType', {
    query: {
      type: payload.type,
      offer_hash: payload.offer_hash,
    }
  });
  yield put({
    type: 'SET_TYPE_OFFERS',
    payload: {
      offers: response.offers,
      liveBtcPrice: response.liveBtcPrice,
      cachedBtcPrice: response.cachedBtcPrice || 0,
    }
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* updateOfferDetais(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.post, '/offers/update', {
    body: {
      data: payload.data,
    }
  });
  yield put({
    $global: true,
    type: 'FETCH_OFFERS',
  });

  yield put({ $global: true, type: 'STOP_LOADER' });

  payload.onClose && payload.onClose();

  return true;
}

export default function* ({ takeFirst, takeLatest, takeEvery }) {
  yield [
    takeEvery('UPDATE_OFFER_DETAILS', updateOfferDetais),
    takeLatest('FETCH_OFFERS_BY_TYPE', fetchOffersByType),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Offers/OfferDetails/OfferDetails.sagas.js